module.exports = __webpack_public_path__ + "img/icon-score5.aef4c645.svg";